module.exports = __webpack_public_path__ + "static/media/127.3e81bfaf.webp";